'use client'
import React, { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import CustomLink from '@/shared/components/customLink'
import Button from '@/shared/components/button'
import { type UrlObject } from 'url'

type ItemProp = { navItem: string; active?: boolean; url?: string | undefined; value?: string }

type commonNavProps = {
	items?: ItemProp[]
	asButton?: boolean
	className?: string
	activeTabClass?: string
	tabClassName?: string
	variant?: 'underlined' | 'pills'
	isActive?: (_: ItemProp) => boolean
	onTabChange?: (_: ItemProp) => void
}

const CommonNav = ({
	items,
	asButton,
	onTabChange,
	isActive,
	className,
	tabClassName = '',
	activeTabClass = '',
	variant = 'pills',
}: commonNavProps) => {
	const asPath = usePathname()
	useEffect(() => {
		const active = typeof window !== 'undefined' && document.getElementById(asPath)
		if (active) active.scrollIntoView({ block: 'end', inline: 'center' })
	}, [])

	const Tabs = (item: ItemProp) => {
		const ActiveClass = asButton ? isActive && isActive(item) : item?.active
		const className = {
			pills: `!px-3 mr-2 border-1 rounded-lg h-8 leading-4 ${
				ActiveClass
					? `text-xs font-bold !bg-buttonBg hover:bg-buttonBg border-buttonBg !rounded-lg dark:!text-textOffWhite !text-white hover:text-white  ${activeTabClass}`
					: 'text-xs font-normal dark:!bg-transparent !bg-white !rounded-lg !border-tabBorder !text-buttonText dark:hover:!bg-buttonBg hover:!bg-buttonBg hover:!text-white '
			}`,
			underlined: ` !px-2 mr-4 !border-b-2 border-b-transparent  text-t-origin h-12 leading-4 bg-transparent hover:bg-transparent !rounded-none whitespace-nowrap text-sm sm:text-base !border-0 ${
				ActiveClass ? `${activeTabClass ? activeTabClass : '!border-b-underLine !text-textOffWhite !font-bold'}` : '!text-textDselected hover:!border-b-underLine'
			}`,
		}
		const Component = asButton ? (
			<Button.Small
				onClick={asButton ? () => onTabChange && onTabChange(item) : undefined}
				className={`${tabClassName} ${className[variant]}`}>
				{item?.navItem}
			</Button.Small>
		) : (
			<CustomLink
				href={item?.url as string | (UrlObject & string)}
				className={`${tabClassName} ${className[variant]} flex items-center text-base transition-colors`}
				id={item?.url}>
				{item?.navItem}
			</CustomLink>
		)
		return Component
	}

	return (
		<>
			<div
				className={`scroll-list ${variant === 'underlined' ? 'sm:mx-0 md:px-0 border-b-2 border-tabBorder' : ''} ${
					className ? className : ''
				}`}>
				{items?.map((item: ItemProp) => {
					return <React.Fragment key={item?.navItem}>{Tabs(item)}</React.Fragment>
				})}
			</div>
		</>
	)
}

export default CommonNav
